module.exports = __webpack_public_path__ + "media/images/icons/more-0bedca9b719c239301218f77a9fb357e.svg";